
















































import Vue, { PropType } from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { ProductEntity } from '@/entities/product.entity';

@Component<DialogOrderSuccess>({})
export default class DialogOrderSuccess extends Vue {
  @Prop({ type: Boolean })
  value: boolean;

  @Prop({ type: Object as PropType<ProductEntity>, required: true })
  product: ProductEntity;
}
